<template>
  <div class="conceptos">
    <!-- <md-autocomplete
    v-model="conceptSelected"
    :md-options="conceptosNames"
    md-layout="box"
    md-dense
    @md-selected="hola">
    <label>Conceptos de pago</label>
  </md-autocomplete> -->

    <md-autocomplete
      v-model="conceptSelected"
      :md-options="listConcepts"
      md-layout="box"
      md-dense
      @md-selected="linkConcept"
    >
      <label>Conceptos de pago</label>
      <template slot="md-autocomplete-item" slot-scope="{ item }">
        {{ item.name }}
      </template>
    </md-autocomplete>

    <!-- <div class="conceptos__container">
      <md-card md-with-hover v-for="item in myConcepts" :key="item.id">
        <md-ripple>
          <md-card-content>
            {{ item.name || "" }}
          </md-card-content>

          <md-card-actions>
            <md-button @click="deleteConcept(item.id)">Eliminar</md-button>
          </md-card-actions>
        </md-ripple>
      </md-card>
    </div> -->
    <div class="conceptos__container conceptos__container--table">
      <md-table
        v-model="conceptComp"
        md-sort="name"
        md-sort-order="asc"
        md-card
        @md-selected="onSelect"
      >
        <md-table-toolbar>
          <h1 class="md-title">Conceptos agregados a la empresa</h1>
        </md-table-toolbar>
        <md-table-toolbar
          slot="md-table-alternate-header"
          slot-scope="{ count }"
        >
          <div class="md-toolbar-section-start">
            {{ getAlternateLabel(count) }}
          </div>

          <div class="md-toolbar-section-end">
            <md-button class="md-icon-button" @click="deleteSelect">
              <md-icon>delete</md-icon>
            </md-button>
          </div>
        </md-table-toolbar>
        <md-table-empty-state
          md-label="No se encontraron registros"
          :md-description="`No se encontró ningún concepto para la empresa.`"
        >
          
        </md-table-empty-state>
        <md-table-row
          slot="md-table-row"
          slot-scope="{ item }"
          :md-disabled="item.name.includes('Stave')"
          md-selectable="multiple"
          md-auto-select
        >
          <md-table-cell md-label=" Nombre" md-sort-by="name">
            <p style="width: 200px;margin-left: 10px;">
              {{ item.name }}
            </p>
          </md-table-cell>
          <md-table-cell
            :md-label="sujetos[key]"
            v-for="(link, key) in item.linkToMap"
            :key="`${item.code}-${key}`"
          >
            <md-checkbox class="md-primary" :value="!link"></md-checkbox>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { setTimeout } from "timers";

export default {
  props: {
    value: Object,
  },
  created() {
    this.getItdConcepts();
  },
  data: () => ({
    ldata: [],
    conceptSelected: null,
    selected: [],
    sujetos: {
      p01: "ESSALUD SEGURO REGULAR PENSIONISTA",
      p02: "CONTRIB. SOLIDARIA ASISTENCIA PREVIS",
      w01: "SISTEMA NACIONAL DE PENSIONES 19990",
      w02: "SISTEMA PRIVADO DE PENSIONES",
      w03: "FONDO COMPL DE JUBIL MIN, MET Y SIDER (1)",
      w04: "RÉG.ESP. PENSIONES   TRAB. PESQUERO",
      w05: "RENTA 5TA CATEGORÍA RETENCIONES",
      e01: "ESSALUD SEGURO REGULAR TRABAJADOR",
      e02: "ESSALUD - CBSSP - SEG TRAB PESQUERO",
      e03: "ESSALUD SEGURO AGRARIO / ACUICULTOR",
      e04: "ESSALUD SCTR",
      e05: "IMPUESTO EXTRAORD. DE SOLIDARIDAD (8)",
      e06: "FONDO DERECHOS SOCIALES DEL ARTISTA",
      e07: "SENATI",
    },
  }),
  computed: {
    ...mapGetters({
      listConcepts: "listConcepts",
      myConcepts: "myConcepts",
    }),
    conceptComp: {
      get() {
        return this.myConcepts;
      },
      set(val) {},
    },
  },
  methods: {
    ...mapActions({
      getItdConcepts: "getItdConcepts",
      unlinkConcept: "unlinkConcept",
      getDetailBusiness: "getDetailBusiness",
      addConcept: "addConcept",
    }),

    hola(item) {
      console.log("hola", item);
      setTimeout(() => {
        this.conceptSelected = null;
      }, 1000);
    },

    linkConcept(item) {
      console.log("item: ", item);
      this.conceptSelected = item.name;

      this.addConcept({ conceptId: item.id }).then((r) => {
        if (r.status == 200) {
          console.log("concepto agregado");
          setTimeout(() => {
            this.conceptSelected = "";
          }, 1000);
          this.getDetailBusiness(this.$store.state.business.businessId).then((res) => {
            if (res.status == 200)
              console.log("lista de conpceptos atualizados");
          });
        }
      });
    },
    deleteSelect(){
      console.log(this.selected);
      for(let concept of this.selected){
        this.deleteConcept(concept.id)
        // console.log(i);
        
      }
    },
    deleteConcept(concept) {
      this.unlinkConcept({ conceptId: concept }).then((r) => {
        if (r.status == 200) {
          this.getDetailBusiness(this.$store.state.business.businessId).then((res) => {
            if (res.status == 200) {
              console.log("detalles de la emp actualizados");
              // this.value = res.data
            }
          });
        }
      });
    },
    onSelect(items) {
      this.selected = items;
    },
    getAlternateLabel(count) {
      let plural = "";

      if (count > 1) {
        plural = "s";
      }

      return `${count} concepto${plural} seleccionado${plural}`;
    },
  },
};
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #C63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//3-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img+$img);
}
//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}

//8-TRUMPS
.priority {
  color: $b-orange;
}
.md-card {
  // width: 320px;
  margin: 4px;
}
.md-card-actions {
  padding: 0 8px 8px 0;
}
.md-button {
  height: auto;
}

.conceptos {
  padding: 2rem 0;

  &__container {
    margin-top: 2rem;
    height: 100%;
    @include mq($sm) {
      display: flex;
      flex-wrap: wrap;
    }
  }

  &__option {
    margin-bottom: 1.5rem;
    @include mq($sm) {
      width: 30rem;
      margin-right: 1rem;
    }
  }
  &__title {
    color: $b-blue-dark;
    font-size: 1.2rem;
  }
  &__input {
    height: 3rem;
    display: block;
    width: 100%;
    border-radius: 3px;
    border: 1px solid #d7dae2;
    box-shadow: 0px 2px 3px rgba(#000, 0.05);
    padding-left: 1rem;
    margin-top: 0.5rem;
  }
}

.add-concept {
  background-color: $b-orange;
  color: #fff;
  border-radius: 3px;
  padding: 0.5rem 1.5rem;
}

.md-checkbox.md-theme-default.md-disabled.md-checked .md-checkbox-container{
      background-color: #000000 !important;
    // background-color: var(--md-theme-default-primary, #000000);
    border-color: #000000 !important;
    // border-color: var(--md-theme-default-primary, #000000);
}
</style>
